import React, { useState } from 'react';
import { observer } from 'mobx-react';

import { useStores } from '@/hooks/use-stores';
import gtag from '@/utils/gtag';
import { EPLockContainer } from './styled';
import EPTierTooltip from './EPTierTooltip';

type Props = {
  label: string;
  icon: React.ReactNode;
  tooltipTitle?: string | React.ReactElement;
  tooltipPlacement?: string;
  tooltipWidth?: number;
  tooltipTextPart1?: string | React.ReactElement;
  tooltipTextPart2?: string | React.ReactElement;
  tooltipClickableText?: string;
  emailRequestTypeOfInterestedPackage?: string;
  emailRequestButtonClicked?: string;
  emailRequestWhichScreen?: string;
  customMessage?: string;
  shouldShowTooltip?: boolean;
  disabledClick?: boolean;
  onClickHandler?: () => void;
};

const EPTierLock = observer(
  ({
    label,
    icon,
    tooltipTitle,
    tooltipTextPart1,
    tooltipTextPart2,
    tooltipClickableText,
    tooltipPlacement,
    tooltipWidth,
    emailRequestTypeOfInterestedPackage,
    emailRequestButtonClicked,
    emailRequestWhichScreen,
    customMessage,
    shouldShowTooltip,
    disabledClick = false,
    onClickHandler,
  }: Props) => {
    const [isTierRequestModalOpen, setIsTierRequestModalOpen] = useState(false);
    const { stationStore } = useStores();

    const onClick = () => {
      if (onClickHandler) onClickHandler();
      else {
        stationStore.updateRequestTier({
          emailRequestTypeOfInterestedPackage,
          emailRequestButtonClicked,
          emailRequestWhichScreen,
          customMessage,
        });
        setIsTierRequestModalOpen(true);
      }
      gtag.campaignClick('EcoPlantLight', emailRequestWhichScreen, emailRequestButtonClicked);
    };

    const onModalClose = () => {
      setIsTierRequestModalOpen(false);
    };

    return (
      <EPLockContainer>
        <EPTierTooltip
          title={tooltipTitle}
          textPart1={tooltipTextPart1}
          textPart2={tooltipTextPart2}
          clickableText={tooltipClickableText}
          tooltipPlacement={tooltipPlacement}
          initialIsTierRequestModalOpen={isTierRequestModalOpen}
          tooltipWidth={tooltipWidth}
          onModalCloseHandler={onModalClose}
          emailRequestTypeOfInterestedPackage={emailRequestTypeOfInterestedPackage}
          emailRequestButtonClicked={`${emailRequestButtonClicked} - Tooltip`}
          emailRequestWhichScreen={emailRequestWhichScreen}
          shouldShowTooltip={shouldShowTooltip}
        >
          <div className={`toggle ${disabledClick ? 'unclickable' : 'clickable'}`} onClick={onClick}>
            {icon && <div className="toggle-handle">{icon}</div>}
            <div>
              <p className="label">{label}</p>
            </div>
          </div>
        </EPTierTooltip>
      </EPLockContainer>
    );
  },
);

export default EPTierLock;
